<template>
  <head>
    <meta charset="utf-8" />
    <title>Biller | {{logsName}}'s Details</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Keep your finances and membership up to date" name="description" />
    <meta content="" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>

    <!-- Start right Content here -->
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">All User logs</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a @click="gotTo('dashboard')" href="javascript: void(0)">Dashboards</a></li>
                    <li class="breadcrumb-item"><a @click="gotTo('users')" href="javascript: void(0)">All users</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0)">{{user.names}}</a></li>
                    <li class="breadcrumb-item active">User logs</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- user details -->
          <div v-if="logs.length<1 & loading === false" class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-4">
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar-md mr-15px ">
                            <h1 class="avatar-title rounded-circle ">
                              CO
                            </h1>
                          </div>
                        </div>
                        <div class="flex-grow-1 align-self-center">
                          <div class="text-muted">
                            <h5 class="mb-1">{{ user.names }}</h5>
                            <p class="mb-0">{{user.category}} (ID {{user.idNo}})</p>
                            <p class="text-muted mb-0 d-flex align-items-center">
                              <a href="tel:0704549859"
                                 class="d-flex align-items-center"><i
                                  class="mdi mdi-phone me-2 font-size-18"></i> {{maskPhoneNumberInText(user.phoneNumber)}}</a> <span class="px-3 px-3">|</span>
                              <a class="d-flex align-items-center"
                                 href="mailto:email@email.com"><i
                                  class="mdi mdi-email-outline font-size-18 me-2"></i>
                                {{user.email}}</a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 align-self-center">
                      <div class="text-lg-center mt-4 mt-lg-0">
                        <div class="row">
                          <div class="col-3">
                            <div>
                              <p class="text-muted text-truncate mb-2">Sub County</p>
                              <h6 class="mb-0">{{user.subCountyName}}</h6>
                            </div>
                          </div>
                          <div class="col-3">
                            <div>
                              <p class="text-muted text-truncate mb-2">Ward</p>
                              <h6 class="mb-0">{{user.wardName}}</h6>
                            </div>
                          </div>
                          <div class="col-3">
                            <div>
                              <p class="text-muted text-truncate mb-2">Last Seen</p>
                              <h6 class="mb-0">{{user.lastSeen}}</h6>
                            </div>
                          </div>

                          <div class="col-3">
                            <div>
                              <p class="text-muted text-truncate mb-2">Current Zone</p>
                              <h6 class="mb-0">{{user.zone}}</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-2 d-lg-block">
                      <div class="clearfix mt-4 mt-lg-0">
                        <div class="dropdown float-end">
                          <div class="d-flex flex-column me-3 pe-3">
                            <span class="pr-3 fw-semibold mb-2">Added By</span>
                            <a> {{user.createdBy}} On {{user.dateCreated}}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end row -->
                </div>
              </div>
            </div>
          </div>
          <!-- end of user details -->

          <!-- Main content -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 align-items-center d-none animated delete-tool-bar" role="toolbar">
                    <button type="button" class="btn btn-primary waves-effect btn-label waves-light me-3">
                      <i class="bx bx-trash label-icon"></i> Delete Contact(s)
                    </button>
                    <button type="button" class="btn btn-primary waves-effect btn-label waves-light me-3">
                      <i class="mdi mdi-plus label-icon"></i> Compose Message
                    </button>
                  </div>
                </div>

                <div class="card-header bg-white w-100 border-bottom">
                  <div class="row align-items-center">
                    <!-- Download Buttons -->
                    <div class="col-md-3">
                      <div class="btn-group" role="group">
                        <!-- Download Current Page -->
                        <button
                            @click="downloadCurrentPage()"
                            type="button"
                            class="btn btn-success btn-sm"
                            :disabled="logs.length === 0">
                          <i class="bx bxs-download font-size-16"></i>
                          <span class="d-md-inline ms-1">Current ({{logs.length}})</span>
                        </button>

                        <!-- Download All Logs -->
                        <button
                            @click="downloadAllLogs()"
                            type="button"
                            class="btn btn-primary btn-sm"
                            :disabled="isDownloadingAll || !summary || summary.count === 0">
                            <span v-if="isDownloadingAll">
                              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                              Downloading...
                            </span>
                          <span v-else>
                              <i class="bx bxs-cloud-download font-size-16"></i>
                              <span class="d-md-inline ms-1">All ({{numberFormat(summary ? summary.count : 0)}})</span>
                            </span>
                        </button>
                      </div>
                    </div>

                    <!-- Date Filters -->
                    <div class="col-md-2">
                      <label class="form-label small mb-1">Date From</label>
                      <input v-model="dateFrom" class="form-control form-control-sm" type="date">
                    </div>

                    <div class="col-md-2">
                      <label class="form-label small mb-1">Date To</label>
                      <input v-model="dateTo" class="form-control form-control-sm" type="date">
                    </div>

                    <!-- Quick Date Filters -->
                    <div class="col-md-2">
                      <label class="form-label small mb-1">Quick Filters</label>
                      <div class="d-flex gap-1">
                        <button @click="setDateRange('today')" type="button" class="btn btn-outline-primary btn-sm">Today</button>
                        <button @click="setDateRange('week')" type="button" class="btn btn-outline-primary btn-sm">Week</button>
                        <button @click="setDateRange('month')" type="button" class="btn btn-outline-primary btn-sm">Month</button>
                      </div>
                    </div>

                    <!-- Search -->
                    <div class="col-md-3">
                      <label class="form-label small mb-1">Search Logs</label>
                      <div class="search-box mb-0 flex-grow-1">
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control form-control-sm bg-light border-light rounded" placeholder="Search logs...">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Summary Row -->
                  <div class="row mt-3 pt-3 border-top" v-if="summary && summary.count > 0">
                    <div class="col-12">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <small class="text-muted">
                            Showing logs from <strong>{{ formatDate(dateFrom) }}</strong> to <strong>{{ formatDate(dateTo) }}</strong>
                          </small>
                        </div>
                        <div>
                          <strong class="text-primary">{{ numberFormat(summary.count) }} Total Logs</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <table class="table align-middle table-nowrap table-hover dt-responsive contacts-table">
                    <thead class="table-light">
                    <tr>
                      <th scope="col" style="width: 200px;">Date</th>
                      <th scope="col">Details</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in logs" :value="item" :key="index">
                      <td><span class="fw-semibold">{{getHumanDate(item.date)}}</span></td>
                      <td>{{maskPhoneNumberInText(item.description)}}</td>
                    </tr>
                    </tbody>
                  </table>

                  <div v-if="loading" class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center d-flex justify-content-center">
                    <div class="p-5 py-0 pt-3">
                      <div class="p-5">
                        <div class="spinner-border text-info m-1" role="status">
                          <span class="sr-only text-uppercase">Loading...</span>
                        </div>
                      </div>
                    </div>
                    <h4 class="text-uppercase">Loading Data</h4>
                    <div class="col-sm-12 col-md-8 col-lg-5">
                      <p>We are fetching the data for you. It will be ready soon. Please wait and have fun. Thank you for your interest.</p>
                    </div>
                  </div>

                  <div v-if="logs.length<1 & loading === false" class="card-body d-sm-none d-md-block px-5 d-flex flex-column justify-items-center align-items-center text-center">
                    <div class="p-5 py-0 pt-3">
                      <img :src="'./assets/images/no-results.png'" class="img mb-4" alt="No search results"/>
                    </div>
                    <h4>No Results To Show</h4>
                    <p>Sorry, we could not find any results that match your search or filter criteria. Please try using different keywords or filters.</p>
                  </div>

                  <div class="card-footer bg-white" v-if="logs.length > 0">
                    <nav aria-label="Page navigation example" class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                          <span class="pr-3 pb-0 mb-0 font-13px">
                            <span>Rows Per Page</span>
                          </span>
                        <select class="form-select w-auto font-13px" v-model="pageSize">
                          <option value="10">10 Rows</option>
                          <option value="25">25 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                          <option value="150">150 Rows</option>
                          <option value="200">200 Rows</option>
                          <option value="500">500 Rows</option>
                          <option value="1000">1000 Rows</option>
                          <option value="5000">5000 Rows</option>
                          <option value="10000">10000 Rows</option>
                        </select>
                      </div>

                      <ul class="pagination">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <a class="page-link" tabindex="-1" @click="prevPage" :disabled="currentPage === 1">Previous</a>
                        </li>
                        <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page" class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <a class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end row -->

        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Download Progress Modal with Pause/Resume and Time Estimation -->
      <div class="modal fade" id="downloadProgressModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title text-white">
                <i class="bx bxs-download me-2"></i>Downloading All Logs
              </h5>
            </div>
            <div class="modal-body">
              <div class="text-center mb-3">
                <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status" v-if="!downloadPaused">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div v-else class="mb-3">
                  <i class="bx bx-pause-circle text-warning" style="font-size: 3rem;"></i>
                </div>
                <h5 v-if="!downloadPaused">Please wait while we download your logs...</h5>
                <h5 v-else class="text-warning">Download Paused</h5>

                <!-- Estimated Time Remaining -->
                <div v-if="downloadProgress.estimatedTimeRemaining && !downloadPaused" class="mt-2">
                  <p class="text-muted mb-1">
                    <i class="bx bx-time-five me-1"></i>
                    <strong>{{ formatTimeRemaining(downloadProgress.estimatedTimeRemaining) }}</strong> remaining
                  </p>
                  <small class="text-muted">
                    Average speed: {{ downloadProgress.averageSpeed }} records/sec
                  </small>
                </div>

                <p class="text-muted mt-2">{{ downloadPaused ? 'You can resume or cancel the download.' : 'This may take several minutes depending on the amount of data.' }}</p>
              </div>

              <div class="progress mb-3" style="height: 25px;">
                <div
                    class="progress-bar progress-bar-striped"
                    :class="{'progress-bar-animated': !downloadPaused, 'bg-warning': downloadPaused}"
                    role="progressbar"
                    :style="{ width: downloadProgress.percentage + '%' }"
                    :aria-valuenow="downloadProgress.percentage"
                    aria-valuemin="0"
                    aria-valuemax="100">
                  {{ downloadProgress.percentage }}%
                </div>
              </div>

              <div class="d-flex justify-content-between text-muted small mb-3">
                <span>Page {{ downloadProgress.current }} of {{ downloadProgress.total }}</span>
                <span>{{ downloadProgress.records }} / {{ numberFormat(downloadProgress.totalRecords) }} records</span>
              </div>

              <!-- Error Display -->
              <div v-if="downloadError" class="alert alert-danger d-flex align-items-center" role="alert">
                <i class="bx bx-error-circle me-2"></i>
                <div class="flex-grow-1">
                  <strong>Error:</strong> {{ downloadError }}
                  <br>
                  <small>You can retry from where it stopped or cancel the download.</small>
                </div>
              </div>

              <!-- Retry Count Display -->
              <div v-if="downloadRetryCount > 0" class="alert alert-warning d-flex align-items-center mb-3" role="alert">
                <i class="bx bx-info-circle me-2"></i>
                <small>Retry attempt {{ downloadRetryCount }} of 3</small>
              </div>

              <!-- Action Buttons -->
              <div class="d-flex gap-2 justify-content-center mb-3">
                <button
                    v-if="!downloadPaused && !downloadError"
                    @click="pauseDownload"
                    class="btn btn-warning btn-sm">
                  <i class="bx bx-pause me-1"></i>Pause
                </button>
                <button
                    v-if="downloadPaused || downloadError"
                    @click="resumeDownload"
                    class="btn btn-success btn-sm">
                  <i class="bx bx-play me-1"></i>Resume
                </button>
                <button
                    @click="cancelDownload"
                    class="btn btn-danger btn-sm">
                  <i class="bx bx-x me-1"></i>Cancel
                </button>
              </div>

              <div class="alert alert-info d-flex align-items-center" role="alert">
                <i class="bx bx-info-circle me-2"></i>
                <small>{{ downloadPaused ? 'Download is paused. Your progress has been saved.' : 'Please do not close this window or navigate away.' }}</small>
              </div>

              <!-- Download Statistics -->
              <div v-if="downloadProgress.records > 0" class="mt-3 pt-3 border-top">
                <div class="row text-center">
                  <div class="col-4">
                    <small class="text-muted d-block">Downloaded</small>
                    <strong>{{ numberFormat(downloadProgress.records) }}</strong>
                  </div>
                  <div class="col-4">
                    <small class="text-muted d-block">Remaining</small>
                    <strong>{{ numberFormat(downloadProgress.totalRecords - downloadProgress.records) }}</strong>
                  </div>
                  <div class="col-4">
                    <small class="text-muted d-block">Success Rate</small>
                    <strong>{{ getSuccessRate() }}%</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">©Best Birdy</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Best Birdy Billing system.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->
  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import {authUrl, biller, execute} from "@/api";
import moment from 'moment';

export default {
  name: "all-user-logs",
  components: {NavigationBar},
  data() {
    return{
      download:'Download',
      search:'',
      loading:true,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      summary: null,

      // Date filters
      dateFrom: '',
      dateTo: '',

      user: {
        id: null,
        names: null,
        gender: null,
        email: null,
        phoneNumber: null,
        idNo: null,
        password: null,
        category: null,
        dateCreated:null,
        zone: null,
        subCountyID:null,
        subCountyName: null,
        wardID: null,
        wardName: null,
        lat: null,
        lng: null,
        address: null,
        lastSeen: null,
        status: null,
        des:null,
        target: null,
        permission: null,
        dailyTargets: null,
        monthlyTargets: null,
        financialYearTargets:null,
        createdBy: null
      },
      logsName:'',
      message:null,
      logs:[],

      // Download All functionality with pause/resume and time estimation
      isDownloadingAll: false,
      downloadPaused: false,
      downloadCancelled: false,
      downloadError: null,
      downloadRetryCount: 0,
      maxRetries: 3,
      downloadProgress: {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      },
      allLogsData: [],
      downloadState: {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      }
    }
  },
  computed: {
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    endIndex() {
      return this.currentPage * this.pageSize;
    },
  },
  watch: {
    pageSize(newPageSize) {
      this.getLogs("")
      const totalItems = this.summary ? this.summary.count : 0;
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;
    },
    selectedItem: {
      handler() {
        this.getLogs(this.selectedItem);
      }
    },
    search: {
      handler() {
        this.currentPage = 1;
        this.getLogs("");
      }
    },
    dateFrom: {
      handler() {
        if (this.dateFrom && this.dateTo) {
          this.currentPage = 1;
          this.getLogs("");
        }
      }
    },
    dateTo: {
      handler() {
        if (this.dateFrom && this.dateTo) {
          this.currentPage = 1;
          this.getLogs("");
        }
      }
    }
  },
  mounted() {
    // Set default date to today
    this.dateFrom = moment().format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');

    this.getLogs()
    this.menuAccess()
  },
  methods:{
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num || 0)
    },

    formatDate(date) {
      return moment(date).format('MMM DD, YYYY');
    },

    setDateRange(preset) {
      const today = moment();

      switch(preset) {
        case 'today':
          this.dateFrom = today.format('YYYY-MM-DD');
          this.dateTo = today.format('YYYY-MM-DD');
          break;
        case 'week':
          this.dateFrom = today.startOf('week').format('YYYY-MM-DD');
          this.dateTo = today.endOf('week').format('YYYY-MM-DD');
          break;
        case 'month':
          this.dateFrom = today.startOf('month').format('YYYY-MM-DD');
          this.dateTo = today.endOf('month').format('YYYY-MM-DD');
          break;
      }
    },

    // Format time remaining in human-readable format
    formatTimeRemaining(seconds) {
      if (!seconds || seconds <= 0) return 'Calculating...';

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      if (hours > 0) {
        return `${hours}h ${minutes}m ${secs}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${secs}s`;
      } else {
        return `${secs}s`;
      }
    },

    // Calculate estimated time remaining
    calculateEstimatedTime() {
      if (!this.downloadProgress.startTime || this.downloadProgress.current === 0) {
        return;
      }

      const elapsedTime = (Date.now() - this.downloadProgress.startTime) / 1000;
      const recordsDownloaded = this.downloadProgress.records;
      const remainingRecords = this.downloadProgress.totalRecords - recordsDownloaded;

      if (recordsDownloaded > 0 && elapsedTime > 0) {
        const averageSpeed = recordsDownloaded / elapsedTime;
        this.downloadProgress.averageSpeed = averageSpeed.toFixed(2);

        const estimatedTimeRemaining = remainingRecords / averageSpeed;
        this.downloadProgress.estimatedTimeRemaining = estimatedTimeRemaining;
      }
    },

    // Get Success Rate
    getSuccessRate() {
      if (this.downloadProgress.total === 0) return 100;
      const successfulPages = this.downloadProgress.current - this.downloadRetryCount;
      return Math.round((successfulPages / this.downloadProgress.total) * 100);
    },

    // Pause Download
    pauseDownload() {
      this.downloadPaused = true;
      console.log('Download paused at page:', this.downloadState.currentPage);
    },

    // Resume Download
    async resumeDownload() {
      this.downloadPaused = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;

      console.log('Resuming download from page:', this.downloadState.currentPage + 1);

      await this.continueDownload();
    },

    // Cancel Download
    cancelDownload() {
      const confirmed = confirm('Are you sure you want to cancel the download? All progress will be lost.');

      if (confirmed) {
        this.downloadCancelled = true;
        this.closeDownloadModal();
      }
    },

    // Close Download Modal
    closeDownloadModal() {
      const modalElement = document.getElementById('downloadProgressModal');
      if (modalElement) {
        const existingModal = bootstrap.Modal.getInstance(modalElement);
        if (existingModal) {
          existingModal.hide();
        }
      }

      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      // Reset state
      this.isDownloadingAll = false;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allLogsData = [];
      this.downloadProgress = {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };
      this.downloadState = {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      };
    },

    maskPhoneNumberInText(text) {
      if (!text || typeof text !== 'string') {
        return text;
      }

      const phoneNumberPattern = /\b\d{10,}\b/g;

      return text.replace(phoneNumberPattern, (match) => {
        const length = match.length;
        if (length > 4) {
          return match.slice(0, 2) + match.slice(2, -2).replace(/\d/g, '*') + match.slice(-2);
        }
        return match;
      });
    },

    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "All User Logs");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then(() => {})
          .catch(() => {});
    },

    // Download Current Page (Client-side CSV generation)
    downloadCurrentPage() {
      if (this.logs.length === 0) {
        alert('No data available to download');
        return;
      }

      try {
        const csv = this.generateLogsCSV(this.logs);

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `Audit_Logs_Page_${this.currentPage}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        alert(`Successfully downloaded ${this.logs.length} logs from current page`);
      } catch (error) {
        console.error('Download error:', error);
        alert('Failed to download data: ' + error.message);
      }
    },

    // Download All Logs with Pause/Resume/Retry and Time Estimation
    async downloadAllLogs() {
      if (!this.summary || this.summary.count === 0) {
        alert('No logs available to download');
        return;
      }

      const isConfirmed = confirm(
          `You are about to download all ${this.numberFormat(this.summary.count)} logs from ${this.dateFrom} to ${this.dateTo}. This may take several minutes. Do you want to continue?`
      );

      if (!isConfirmed) return;

      this.isDownloadingAll = true;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allLogsData = [];

      const batchSize = 1000;
      const totalRecords = parseInt(this.summary.count);
      const totalPages = Math.ceil(totalRecords / batchSize);

      this.downloadState = {
        startPage: 1,
        currentPage: 0,
        batchSize: batchSize,
        totalPages: totalPages,
        accumulatedData: []
      };

      this.downloadProgress = {
        current: 0,
        total: totalPages,
        percentage: 0,
        records: 0,
        totalRecords: totalRecords,
        startTime: Date.now(),
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };

      const modalElement = document.getElementById('downloadProgressModal');
      const progressModal = new bootstrap.Modal(modalElement);
      progressModal.show();

      await this.continueDownload();
    },

    // Continue Download (used by both initial download and resume)
    async continueDownload() {
      try {
        const startPage = this.downloadState.currentPage + 1;
        const totalPages = this.downloadState.totalPages;

        for (let page = startPage; page <= totalPages; page++) {
          if (this.downloadPaused) {
            console.log('Download paused, waiting for resume...');
            return;
          }

          if (this.downloadCancelled) {
            console.log('Download cancelled by user');
            return;
          }

          try {
            this.downloadState.currentPage = page;
            this.downloadProgress.current = page;
            this.downloadProgress.percentage = Math.round((page / totalPages) * 100);

            const pageData = await this.fetchLogsPageWithRetry(page, this.downloadState.batchSize);

            if (pageData && pageData.length > 0) {
              this.downloadState.accumulatedData = [...this.downloadState.accumulatedData, ...pageData];
              this.allLogsData = this.downloadState.accumulatedData;
              this.downloadProgress.records = this.allLogsData.length;

              this.calculateEstimatedTime();
            }

            this.downloadRetryCount = 0;
            this.downloadError = null;

            await this.delay(50);

          } catch (error) {
            console.error(`Error fetching page ${page}:`, error);
            this.downloadError = error.message;
            this.downloadPaused = true;
            return;
          }
        }

        await this.finalizeDownload();

      } catch (error) {
        console.error('Download error:', error);
        this.downloadError = error.message;
        this.downloadPaused = true;
      }
    },

    // Fetch Logs Page with Retry Logic
    async fetchLogsPageWithRetry(page, rowsPerPage, retryCount = 0) {
      try {
        const data = new FormData();
        data.append("function", "getAllLogs");
        data.append("search", this.search);
        data.append("page", page);
        data.append("rows_per_page", rowsPerPage);
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);

        const res = await execute(data, authUrl);

        if (res.data.success) {
          return res.data.data.logs || [];
        } else {
          throw new Error(res.data.message || 'Failed to fetch page data');
        }
      } catch (error) {
        if (retryCount < this.maxRetries) {
          this.downloadRetryCount = retryCount + 1;
          console.log(`Retry ${this.downloadRetryCount} for page ${page}`);

          const waitTime = Math.pow(2, retryCount) * 1000;
          await this.delay(waitTime);

          return this.fetchLogsPageWithRetry(page, rowsPerPage, retryCount + 1);
        } else {
          throw new Error(`Failed after ${this.maxRetries} retries: ${error.message}`);
        }
      }
    },

    // Finalize Download
    async finalizeDownload() {
      if (this.allLogsData.length > 0) {
        const csv = this.generateLogsCSV(this.allLogsData);

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        const fileName = `All_Audit_Logs_${this.dateFrom}_to_${this.dateTo}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`;

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        await this.delay(500);

        alert(`Successfully downloaded ${this.allLogsData.length} logs!`);

        this.closeDownloadModal();
      } else {
        alert('No logs found to download');
        this.closeDownloadModal();
      }
    },

    // Delay helper function
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    // Generate CSV from logs data
    generateLogsCSV(data) {
      if (!data || data.length === 0) return '';

      const headers = [
        'NO.',
        'Date',
        'ID Number',
        'Username',
        'Description',
        'Type',
        'Sub County'
      ];

      let csv = headers.join(',') + '\n';

      data.forEach((item, index) => {
        const row = [
          index + 1,
          this.escapeCSV(item.date),
          this.escapeCSV(item.idNo),
          this.escapeCSV(item.username),
          this.escapeCSV(item.description),
          this.escapeCSV(item.type),
          this.escapeCSV(item.subCountyName)
        ];
        csv += row.join(',') + '\n';
      });

      return csv;
    },

    // Escape CSV values
    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return '"' + stringValue.replace(/"/g, '""') + '"';
      }
      return stringValue;
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getLogs("")
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getLogs("")
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getLogs("")
      }
    },

    gotTo(route){
      router.push(route)
    },

    getHumanDate(dateData) {
      const dateObject = new Date(Date.parse(dateData));

      const options = {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      };

      return dateObject.toLocaleString('en-US', options);
    },

    getLogs(){
      this.loading = true
      const data = new FormData();
      data.append("function", "getAllLogs");
      data.append("search", this.search);
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      execute(data,authUrl)
          .then((res) =>{
            this.loading = false
            if (res.data.success) {
              this.logs = res.data.data.logs
              this.summary = res.data.data.resultSummary
              this.totalPages = Math.ceil(this.summary.count / this.pageSize);
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.loading = false
            this.message =e.message
          });
    }
  },
}
</script>

<style scoped>
.btn-group .btn {
  white-space: nowrap;
}

.btn-group .btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

#downloadProgressModal .modal-body {
  padding: 2rem;
}

#downloadProgressModal .progress {
  background-color: #e9ecef;
}

#downloadProgressModal .progress-bar {
  font-weight: 600;
  font-size: 0.875rem;
}

.form-label.small {
  font-size: 0.875rem;
  font-weight: 500;
  color: #6c757d;
  margin-bottom: 0.25rem;
}

.btn-outline-primary.btn-sm {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

.card-header .row {
  margin-bottom: 0;
}

.card-header .row > div {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

/* Pause icon animation */
.bx-pause-circle {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Time remaining display */
.text-muted strong {
  color: #495057;
  font-weight: 600;
}
</style>